import * as breakpoints from './breakpoints';
import * as layout from './layout';
import * as discouragedNeutralPalette from './palette';
import * as discouragedSharefilePalette from './sharefilePalette';
import * as typography from './typography';
import * as styleUtils from './util';

/**
 * @deprecated
 * palette should not be used at all. If you are trying to style a one off special use case component for the `neutral` theme use the `neutralPalette`
 */
var palette = discouragedNeutralPalette;

/**
 * @deprecated
 * neutralPalette should only be used with `fromThemePalette` or `useThemePalette` helpers for very special one-off use cases in the neutral brand only.
 * Instead use `ThemeColor` tokens along with `fromThemeColor` or `useThemeColor` helper methods to ensure compliance with any future styling themes.
 */
var neutralPalette = discouragedNeutralPalette;

/**
 * @deprecated
 * sharefilePalette should only be used with `fromThemePalette` or `useThemePalette` helpers for very special one-off use cases in the `sharefileBrand` only.
 * Instead use `ThemeColor` tokens along with `fromThemeColor` or `useThemeColor` helper methods to ensure compliance with any future styling themes.
 */
var sharefilePalette = discouragedSharefilePalette;
export { breakpoints, layout, palette, neutralPalette, sharefilePalette, styleUtils, typography };